import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import TablePagination from "@material-ui/core/TablePagination";
import DatePicker from "react-datepicker";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import TableFooter from "@material-ui/core/TableFooter";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

import {
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import {
  getSorting,
  getNumberSorting,
  getFloatSorting,
} from "../components/Utils";
import CustomTableHead from "../components/CustomTableHead";
import PopupMessage from "../components/PopupMessage";
import ViewPdf from "../components/ViewPdf";
import CustomPaginatorActions from "../components/CustomPaginatorActions";
import InfoIcon from "@material-ui/icons/InfoOutlined";

import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import SelectAllIcon from "@material-ui/icons/SelectAllOutlined";
import DeselectAllIcon from "@material-ui/icons/TabUnselectedOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";

import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },

  customWidth: {
    maxWidth: 500,
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

const columnData = [
  { id: "date", numeric: false, disablePadding: true, label: "Date" },
  { id: "trace", numeric: false, disablePadding: true, label: "Trace" },
  { id: "checkNumber", numeric: false, disablePadding: true, label: "Check#" },
  { id: "code", numeric: false, disablePadding: true, label: "Code" },
  { id: "type", numeric: false, disablePadding: true, label: "Type" },
  { id: "crdr", numeric: false, disablePadding: true, label: "CR/DR" },
  { id: "transSerial", numeric: false, disablePadding: true, label: "Serial#" },
  { id: "amount", numeric: false, disablePadding: true, label: "Amount($)" },
  {
    id: "transit",
    numeric: false,
    disablePadding: true,
    label: "Orig Transit",
  },
  { id: "nosort", numeric: false, disablePadding: true, label: "More..." },
];

class AchPaidAccountItemsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      inited: false,
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      totalCount: 0,
      order: "asc",
      orderBy: "5",
      canSearch: false,
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      validated: false,
      viewPdf: false,
      collapsedSearch: false,
      searchData: {},
      transType: [],
      items: [],
      searchItemsInProgress: false,
      viewPopup: false,
      selectedSort: "1",   	  
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }

  handleSort(e) {
    this.setState({ selectedSort: e.target.value });
    if (e.target.value === "1") {
      this.setState({ orderBy: "5" });
    }          
    if (e.target.value === "2") {
      this.setState({ orderBy: "4" });
    }
    if (e.target.value === "3") {
      this.setState({ orderBy: "0" });
    }	
  }

  componentDidMount() {
    fetch("on_init_ach_accepted_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        let reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ inited: true });
          this.setState({ searchData: reply.searchData });
          this.setState({ transType: reply.searchData.transType });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
    this.setState({ searchItemsInProgress: false });
  }

  handleSearch(e) {
    if (!this.validateTransType()) {
      return;
    }
    if (!this.validateDates()) {
      return;
    }
    this.setState({ canSearch: true });
    this.setState({ searchItemsInProgress: true });
    this.setState({ page: 0 });
    this.setState({ orderBy: "" });
    this.search(this.getCriteriaObject(0, this.state.rowsPerPage), false);
  }

  handlePdf(e) {
    if (!this.validateTransType()) {
      return;
    }
    if (!this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  validateDates() {
    let start = this.state.startDate;
    let end = this.state.endDate;
    if (start !== null && end !== null && end.isBefore(start, "day")) {
      this.setState({
        errorString: getErrorString(
          "general.error.endDate",
          "End Date is before Start Date"
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  handleCollapse = (event) => {
    this.setState({ collapsedSearch: !this.state.collapsedSearch });
  };

  handleStartDate(date) {
    let data = this.state.searchData;
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      data.startDate = "";
    } else {
      data.startDate = date.format(BACKEND_DATE_FORMAT);
    }
    this.setState({ searchData: data });
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    let data = this.state.searchData;
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      data.endDate = "";
    } else {
      data.endDate = date.format(BACKEND_DATE_FORMAT);
    }
    this.setState({ searchData: data });
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleCheckFrom(e) {
    let data = this.state.searchData;
    this.disableSearch();
    data.fromCheck = e.target.value;
    this.setState({ searchData: data });
  }

  handleCheckTo(e) {
    let data = this.state.searchData;
    this.disableSearch();
    data.toCheck = e.target.value;
    this.setState({ searchData: data });
  }

  handleAmountFrom(e) {
    let data = this.state.searchData;
    this.disableSearch();
    data.fromAmount = e.target.value;
    this.setState({ searchData: data });
  }

  handleAmountTo(e) {
    let data = this.state.searchData;
    this.disableSearch();
    data.toAmount = e.target.value;
    this.setState({ searchData: data });
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    if (this.state.canSearch) {
      this.search(this.getCriteriaObject(0, e.target.value), true);
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    if (this.state.canSearch) {
      this.search(this.getCriteriaObject(page, this.state.rowsPerPage), true);
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.items);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (
        orderBy === "checkNumber" ||
        orderBy === "trace" ||
        orderBy === "transSerial" ||
        orderBy === "transit"
      ) {
        data.sort(getNumberSorting(order, orderBy));
      } else if (orderBy === "amount") {
        data.sort(getFloatSorting(order, "rawAmount"));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      this.setState({ items: data });
    }
  }

  handleCreditDebit = (name) => (event) => {
    this.disableSearch();
    let data = this.state.searchData;
    if (name === "checkedC") {
      data.credit = event.target.checked;
      if (!data.credit && !data.debit) {
        data.debit = true;
      }
    } else {
      data.debit = event.target.checked;
      if (!data.credit && !data.debit) {
        data.credit = true;
      }
    }
    this.setState({ searchData: data });
  };

  handleTransChange = (index) => (event) => {
    this.disableSearch();
    let data = this.state.transType;
    data[index].checked = event.target.checked;
    this.setState({ transType: data });
  };

  handleSelectAll(event, checked) {
    this.disableSearch();
    let data = this.state.transType;
    let index;
    for (index = 0; index < data.length; index++) {
      data[index].checked = checked;
    }
    this.setState({ transType: data });
  }

  handleOrigCompName(event) {
    this.disableSearch();
    let data = this.state.searchData;
    data.origCompanyName = event.target.value;
    this.setState({ searchData: data });
  }

  handleOrigCompId(event) {
    this.disableSearch();
    let data = this.state.searchData;
    data.origCompanyId = event.target.value;
    this.setState({ searchData: data });
  }

  handleOrigTransit(event) {
    this.disableSearch();
    let data = this.state.searchData;
    data.origTransit = event.target.value;
    this.setState({ searchData: data });
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  validateTransType() {
    let data = this.state.transType;
    let index;
    for (index = 0; index < data.length; index++) {
      if (data[index].checked) {
        return true;
      }
    }
    this.setState({
      notifyString: "At least one Transaction Type is required.",
    });
    this.setState({ viewPopup: true });
    return false;
  }

  search(criteriaObject, sortIt) {
    fetch("on_ach_accepted_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(criteriaObject),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else {
          this.setState({ searchItemsInProgress: false });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            let newData = reply.data;
            this.setState({ items: newData });
            this.setState({ totalCount: reply.totalCount });
            this.setState({ totalAmount: reply.totalAmount });
            if (reply.totalCount === 0) {
              this.setState({ viewPopup: true });
              this.setState({
                notifyString: getErrorString(
                  "general.info.search.empty",
                  "Total number of items is 0."
                ),
              });
            } else if (sortIt) {
              this.sort(this.state.orderBy, this.state.order, newData);
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ searchItemsInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  getCriteriaObject(page, rowsPerPage) {
    let data = this.state.searchData;
    data.transType = this.state.transType;
    data.transit = this.props.accountObject.transit;
    data.account = this.props.accountObject.account;
    data.page = page;
    data.rowsPerPage = rowsPerPage;
    data.secureToken = this.props.secureToken;
    return data;
  }

  render() {
    const { classes } = this.props;
    const datePickerTopMargin = this.props.option.id === "O" ? 10 : 6;
    const actionTopMargin = this.props.option.id === "O" ? 4 : 0;
    const { order, orderBy, rowsPerPage, page, totalCount } = this.state;
    let options = this.props.reports;
    let data = this.state.transType;
    let items = this.state.items;
    let { t } = this.props;
    return (
      <div>
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            page={page}
            rowsPerPage={rowsPerPage}
            postData={this.getCriteriaObject(page, rowsPerPage)}
            pdfUrl="on_ach_accepted_pdf_request"
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}

        {!this.state.inited && (
          <div>
            <Paper elevation={5}>
              <FormGroup row>
                <div>
                  <Typography variant="caption">
                    {t("report.label")}&nbsp;&nbsp;
                  </Typography>
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 48,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.props.option.index}
                      input={<Input id="report_options" />}
                      onChange={(event) => this.handleChange(event)}
                    >
                      {options.map((n) => {
                        return <option value={n.index}>{n.description}</option>;
                      })}
                    </NativeSelect>
                    &nbsp;&nbsp;
                  </FormControl>
                </div>
              </FormGroup>
            </Paper>
          </div>
        )}
        {this.state.inited && (
          <div>
            <div>
              <Paper elevation={5}>
                <FormGroup row>
                  <div>
                    <Typography variant="caption">
                      {t("report.label")}&nbsp;&nbsp;
                    </Typography>
                    <FormControl>
                      <NativeSelect
                        style={{
                          height: 48,
                          verticalAlign: "textTop",
                          margin: 0,
                        }}
                        defaultValue={this.props.option.index}
                        input={<Input id="report_options" />}
                        onChange={(event) => this.handleChange(event)}
                      >
                        {options.map((n) => {
                          return (
                            <option value={n.index}>{n.description}</option>
                          );
                        })}
                      </NativeSelect>
                    </FormControl>
                    &nbsp;&nbsp;
                  </div>
                  <div>
                    <Typography variant="caption">
                      {t("startDate.label")}
                      {!this.state.redrawStartDate && (
                        <div style={{ marginTop: datePickerTopMargin }}>
                          <DatePicker
                            isClearable
                            disabledKeyboardNavigation
                            dateFormat="LL"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={this.state.startDate}
                            onChange={(event) => this.handleStartDate(event)}
                            onClickOutside={(event) =>
                              this.handleStartDateOutsideClick(event)
                            }
                            popperContainer={CalendarContainer}
                          />
                        </div>
                      )}
                    </Typography>
                  </div>
                  &nbsp;&nbsp;
                  <div>
                    <Typography variant="caption">
                      {t("endDate.label")}
                      {!this.state.redrawEndDate && (
                        <div style={{ marginTop: datePickerTopMargin }}>
                          <DatePicker
                            isClearable
                            disabledKeyboardNavigation
                            dateFormat="LL"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={this.state.endDate}
                            onChange={(event) => this.handleEndDate(event)}
                            onClickOutside={(event) =>
                              this.handleEndDateOutsideClick(event)
                            }
                            popperContainer={CalendarContainer}
                          />
                        </div>
                      )}
                    </Typography>
                    &nbsp;&nbsp;
                  </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.searchData.credit === true}
                        onChange={this.handleCreditDebit("checkedC")}
                        value="checkedC"
                        color="default"
                      />
                    }
                    label={t("credit.label")}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.searchData.debit === true}
                        onChange={this.handleCreditDebit("checkedD")}
                        value="checkedD"
                        color="default"
                      />
                    }
                    label={t("debit.label")}
                  />
                   <div>
                     <Typography variant="caption">
                       {t("sort.label")}&nbsp;&nbsp;
                     </Typography>
                     <FormControl>
                       <NativeSelect
                          style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                          defaultValue={this.state.selectedSort}
                          input={<Input id="sort_options" />}
                          onChange={(event) => this.handleSort(event)}
                        >                      
                          <option value="1">{t("amount.label")}</option>
                          <option value="2">{t("payee.label")}</option>
                          <option value="3">{t("default.label")}</option>
                        </NativeSelect>
                     </FormControl>
                     &nbsp;&nbsp;
                   </div>                    				  
                  <Tooltip
                    title={
                      t("showSearchResult.tip") + this.props.option.description
                    }
                  >
                    <Button
                      color="primary"
                      style={{ marginTop: actionTopMargin }}
                      onClick={(event) => this.handleSearch(event)}
                    >
                      <SearchIcon />
                      &nbsp;{t("search.button")}
                    </Button>
                  </Tooltip>
                  <Tooltip title={t("viewPdfReport.tip")}>
                    <Button
                      color="primary"
                      style={{ marginTop: actionTopMargin }}
                      onClick={(event) => this.handlePdf(event)}
                    >
                      <PDFViewIcon />
                      &nbsp;{t("pdf.button")}
                    </Button>
                  </Tooltip>
                  {!this.state.collapsedSearch && (
                    <Tooltip title={t("collaspSearch.tip")}>
                      <IconButton
                        style={{ position: "absolute", right: 10, top: 0 }}
                        onClick={(event) => this.handleCollapse(event)}
                      >
                        <ArrowDropUp />
                      </IconButton>
                    </Tooltip>
                  )}
                  {this.state.collapsedSearch && (
                    <Tooltip title={t("expandSearch.tip")}>
                      <IconButton
                        style={{ position: "absolute", right: 10, top: 0 }}
                        onClick={(event) => this.handleCollapse(event)}
                      >
                        <ArrowDropDown />
                      </IconButton>
                    </Tooltip>
                  )}
                </FormGroup>

                {!this.state.collapsedSearch && (
                  <div>
                    <FormGroup row>
                      <TextField
                        margin="dense"
                        id="checkFrom"
                        label={t("checkNoFrom.label")}
                        type="text"
                        defaultValue={this.state.searchData.fromCheck}
                        onChange={(event) => this.handleCheckFrom(event)}
                        onKeyPress={(event) => {
                          return event.charCode >= 48 && event.charCode <= 57
                            ? true
                            : event.preventDefault();
                        }}
                      />
                      &nbsp;&nbsp;
                      <TextField
                        margin="dense"
                        id="checkTo"
                        label={t("checkNoTo.label")}
                        type="text"
                        defaultValue={this.state.searchData.toCheck}
                        onChange={(event) => this.handleCheckTo(event)}
                        onKeyPress={(event) => {
                          return event.charCode >= 48 && event.charCode <= 57
                            ? true
                            : event.preventDefault();
                        }}
                      />
                      &nbsp;&nbsp;
                      <TextField
                        margin="dense"
                        id="amountFrom"
                        label={t("amountFrom.label")}
                        type="text"
                        defaultValue={this.state.searchData.fromAmount}
                        onChange={(event) => this.handleAmountFrom(event)}
                        InputProps={{
                          inputComponent: AmountFormatCustom,
                        }}
                      />
                      &nbsp;&nbsp;
                      <TextField
                        margin="dense"
                        id="amountTo"
                        label={t("amountTo.label")}
                        type="text"
                        defaultValue={this.state.searchData.toAmount}
                        onChange={(event) => this.handleAmountTo(event)}
                        InputProps={{
                          inputComponent: AmountFormatCustom,
                        }}
                      />
                      &nbsp;&nbsp;
                      <TextField
                        margin="dense"
                        id="origTransit"
                        label={t("origTransit.label")}
                        type="text"
                        defaultValue={this.state.searchData.origTransit}
                        onChange={(event) => this.handleOrigTransit(event)}
                        onKeyPress={(event) => {
                          return event.charCode >= 48 && event.charCode <= 57
                            ? true
                            : event.preventDefault();
                        }}
                      />
                      &nbsp;&nbsp;
                      <TextField
                        margin="dense"
                        id="origCompId"
                        label={t("origCompId.label")}
                        type="text"
                        defaultValue={this.state.searchData.origCompanyId}
                        onChange={(event) => this.handleOrigCompId(event)}
                        onKeyPress={(event) => {
                          return event.charCode >= 48 && event.charCode <= 57
                            ? true
                            : event.preventDefault();
                        }}
                      />
                      &nbsp;&nbsp;
                      <TextField
                        margin="dense"
                        id="origCompName"
                        label={t("origCompName.label")}
                        type="text"
                        defaultValue={this.state.searchData.origCompanyName}
                        onChange={(event) => this.handleOrigCompName(event)}
                      />
                    </FormGroup>

                    <FormGroup row>
                      {data.slice(0, data.length / 2).map((n) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={n.checked === true}
                                onChange={this.handleTransChange(n.index)}
                                value={n.index}
                                color="default"
                              />
                            }
                            label={n.descr}
                          />
                        );
                      })}
                      {data.slice(data.length / 2, data.length).map((n) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={n.checked === true}
                                onChange={this.handleTransChange(n.index)}
                                value={n.index}
                                color="default"
                              />
                            }
                            label={n.descr}
                          />
                        );
                      })}
                      &nbsp;&nbsp;
                      <Button
                        color="primary"
                        onClick={(event) => this.handleSelectAll(event, true)}
                      >
                        <SelectAllIcon />
                        &nbsp;{t("selectAll.button")}
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => this.handleSelectAll(event, false)}
                      >
                        <DeselectAllIcon />
                        &nbsp;{t("deselectAll.button")}
                      </Button>
                    </FormGroup>
                  </div>
                )}
              </Paper>
            </div>
            <Divider />
            {this.state.totalCount === 0 &&
              this.state.errorString.length === 0 &&
              this.state.searchItemsInProgress && (
                <div>
                  <CircularProgress className={classes.progress} />
                </div>
              )}
            <TablePagination
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={(event) =>
                this.handleChangeRowsPerPage(event)
              }
              ActionsComponent={CustomPaginatorActions}
            />
            {this.state.canSearch && this.state.totalCount > 0 && (
              <Paper>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {items.map((n) => {
                      return (
                        <TableRow
                          hover
                          className={classes.tableRow}
                          key={n.index}
                        >
                          <TableCell>{n.date}</TableCell>
                          <TableCell>{n.trace}</TableCell>
                          <TableCell>{n.checkNumber}</TableCell>
                          <TableCell>{n.code}</TableCell>
                          <TableCell>{n.type}</TableCell>
                          <TableCell>{n.crDr}</TableCell>
                          <TableCell>{n.transSerial}</TableCell>
                          <TableCell>{n.amount}</TableCell>
                          <TableCell>{n.transit}</TableCell>
                          <Tooltip
                            classes={{ tooltip: classes.customWidth }}
                            title={
                              <div>
                                {t("orig.label")}: {n.originator} <br />
                                {t("companyName.header")}: {n.compName} <br />
                                {t("compId.label")}: {n.compId} <br />
                                {t("description.header")}: {n.compDescr} <br />
                                {t("payInfo.label")}: {n.payInfo} <br />
                                {t("notes.label")}: {n.notes}{" "}
                              </div>
                            }
                          >
                            <TableCell>
                              <InfoIcon color="primary" />
                            </TableCell>
                          </Tooltip>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                  {this.state.totalCount > 0 && (
                    <TableFooter className={classes.boldCell}>
                      <TableRow>
                        <TableCell colSpan={2} className={classes.boldCell}>
                          {t("totalAmount.label")}
                        </TableCell>
                        <TableCell className={classes.boldCell}>
                          {this.state.totalAmount}
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  )}
                </Table>
              </Paper>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(AchPaidAccountItemsPage));
